import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import AppContext from "../../contexts/AppContext";
import HeaderNotifications from "../notifications/HeaderNotifications";
import HeaderMessages from "../messages/HeaderMessages";
class Header extends Component {
    render() {
        return (
            <nav className="navbar navbar-expand-lg fixed-top navbar-light py-2">
                <div className="container-fluid px-5">
                    <NavLink
                        activeClassName='active'
                        className="navbar-brand d-lg-none d-sm-block"
                        to={`/`}
                    >
                        <img
                            src={this.context.state.user.image}
                            className="navbar-brand-img mx-auto"
                            alt=""
                        />
                    </NavLink>
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-toggle="collapse"
                        data-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div
                        className="mx-md-auto collapse navbar-collapse nav-container collapsed-logo w-100"
                        id="navbarSupportedContent"
                    >
                        <div className="navbar-left">
                            <ul className="navbar-nav">
                                <li className="nav-item">
                                    <NavLink
                                        activeClassName='active'
                                        className="nav-link"
                                        to={`/admin/dashboard`}
                                        aria-controls="sidebarDashboards"
                                    >
                                        Dashboard
                                    </NavLink>
                                </li>

                                <li className="nav-item dropdown">
                                    <a
                                        className="nav-link"
                                        id="jobsMenu"
                                        data-toggle="dropdown"
                                        role="button"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        aria-controls="jobsMenu"
                                    >
                                        Users
                                    </a>
                                    <div
                                        className="dropdown-menu hide"
                                        aria-labelledby="jobsMenu"
                                    >
                                        <ul className="nav nav-sm flex-column">
                                            <li className="nav-item">
                                                <NavLink
                                                    activeClassName='active'
                                                    className="nav-link"
                                                    to={`/admin/employers`}
                                                >
                                                    <i className="fe fe-briefcase"></i>{" "}
                                                    Employers
                                                </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink
                                                    activeClassName='active'
                                                    className="nav-link"
                                                    to={`/admin/writers`}
                                                >
                                                    <i className="fe fe-user"></i>{" "}
                                                    Writers
                                                </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink
                                                    activeClassName='active'
                                                    className="nav-link"
                                                    to={`/admin/members`}
                                                >
                                                    <i className="fe fe-list"></i>{" "}
                                                    Members
                                                </NavLink>
                                            </li>
                                        </ul>
                                    </div>
                                </li>

                                <li className="nav-item dropdown">
                                    <a
                                        className="nav-link"
                                        id="Databases"
                                        data-toggle="dropdown"
                                        role="button"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        aria-controls="Databases"
                                    >
                                        Databases
                                    </a>
                                    <div
                                        className="dropdown-menu hide"
                                        aria-labelledby="Databases"
                                    >
                                        <ul className="nav nav-sm flex-column">
                                            <li className="nav-item">
                                                <NavLink
                                                    activeClassName='active'
                                                    to={`/admin/badges`}
                                                    className="nav-link"
                                                >
                                                    Badges
                                                </NavLink>
                                            </li>

                                            <li className="nav-item">
                                                <NavLink
                                                    activeClassName='active'
                                                    to={`/admin/industries`}
                                                    className="nav-link "
                                                >
                                                    Industries
                                                </NavLink>
                                            </li>

                                            <li className="nav-item">
                                                <NavLink
                                                    activeClassName='active'
                                                    to={`/admin/appCategories`}
                                                    className="nav-link "
                                                >
                                                    App Categories
                                                </NavLink>
                                            </li>

                                            <li className="nav-item">
                                                <NavLink
                                                    activeClassName='active'
                                                    to={`/admin/jobCategories`}
                                                    className="nav-link "
                                                >
                                                    {/* Job Categories */}
                                                    Content Types
                                                </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink
                                                    activeClassName='active'
                                                    to={`/admin/jobTypes`}
                                                    className="nav-link "
                                                >
                                                    types
                                                </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink
                                                    activeClassName='active'
                                                    to={`/admin/jobDurations`}
                                                    className="nav-link "
                                                >
                                                    Durations
                                                </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink
                                                    activeClassName='active'
                                                    to={`/admin/jobNiches`}
                                                    className="nav-link "
                                                >
                                                    Niches
                                                </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink
                                                    activeClassName='active'
                                                    to={`/admin/scrapers`}
                                                    className="nav-link"
                                                >
                                                    Scrapers
                                                </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink
                                                    activeClassName='active'
                                                    to={`/admin/rejectedReasons`}
                                                    className="nav-link"
                                                >
                                                    Rejected reasons
                                                </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink
                                                    activeClassName='active'
                                                    to={`/admin/skills`}
                                                    className="nav-link"
                                                >
                                                    Skills
                                                </NavLink>
                                            </li>
                                        </ul>
                                    </div>
                                </li>

                                <li className="nav-item dropdown">
                                    <a
                                        className="nav-link"
                                        id="Accounting"
                                        data-toggle="dropdown"
                                        role="button"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        aria-controls="Accounting"
                                    >
                                        Accounting
                                    </a>
                                    <div
                                        className="dropdown-menu hide"
                                        aria-labelledby="Accounting"
                                    >
                                        <ul className="nav nav-sm flex-column">
                                            <li className="nav-item">
                                                <NavLink
                                                    className="nav-link "
                                                    to={`/admin/paymentsFinancials`}
                                                >
                                                    <i className="fe fe-list"></i>{" "}
                                                    Product Purchases
                                                </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink
                                                    className="nav-link "
                                                    to={`/admin/connectsFinancials`}
                                                >
                                                    <i className="fe fe-list"></i>{" "}
                                                    Connects Purchases
                                                </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink
                                                    className="nav-link "
                                                    to={`/admin/membershipPayments`}
                                                >
                                                    <i className="fe fe-list"></i>{" "}
                                                    Membership Payments
                                                </NavLink>
                                            </li>
                                        </ul>
                                    </div>
                                </li>

                                <li className="nav-item dropdown">
                                    <a
                                        className="nav-link"
                                        id="Products"
                                        data-toggle="dropdown"
                                        role="button"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        aria-controls="Products"
                                    >
                                        Products
                                    </a>
                                    <div
                                        className="dropdown-menu hide"
                                        aria-labelledby="Products"
                                    >
                                        <ul className="nav nav-sm flex-column">
                                            <li className="nav-item">
                                                <NavLink
                                                    activeClassName='active'
                                                    to={`/admin/resources`}
                                                    className="nav-link"
                                                >
                                                    Resources
                                                </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink
                                                    activeClassName='active'
                                                    to={`/admin/guides`}
                                                    className="nav-link"
                                                >
                                                    Guides
                                                </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink
                                                    className="nav-link "
                                                    to={`/admin/connects`}
                                                >
                                                    Connects
                                                </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink
                                                    className="nav-link "
                                                    to={`/admin/articles`}
                                                >
                                                    Article Listings
                                                </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink
                                                    className="nav-link "
                                                    to={`/admin/job-listings`}
                                                >
                                                    Job Listings
                                                </NavLink>
                                            </li>

                                            <li className="nav-item">
                                                <NavLink
                                                    to={`/admin/employerPlans`}
                                                    className="nav-link"
                                                >
                                                    Job Listing Types
                                                </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink
                                                    className="nav-link"
                                                    to={`/admin/writerTips`}
                                                >
                                                    Writer Tips
                                                </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink
                                                    className="nav-link"
                                                    to={`/admin/writerPlans`}
                                                >
                                                    Memberships
                                                </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink
                                                    className="nav-link"
                                                    to={`/admin/coupons`}
                                                >
                                                    Coupons
                                                </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink
                                                    className="nav-link "
                                                    to={`/admin/courses`}
                                                >
                                                    Courses
                                                </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink
                                                    to={`/admin/dynamic-wp-links`}
                                                    className="nav-link"
                                                >
                                                    Dynamic WP Links
                                                </NavLink>
                                            </li>
                                        </ul>
                                    </div>
                                </li>

                                <li className="nav-item dropdown">
                                    <NavLink
                                        className="nav-link"
                                        to={`/admin/appliedBadges`}
                                    >
                                        Badges request
                                    </NavLink>
                                </li>
                                <li className="nav-item dropdown">
                                    <NavLink
                                        className="nav-link"
                                        to={`/admin/topics`}
                                    >
                                        Topic
                                    </NavLink>
                                </li>
                                <li className="nav-item dropdown">
                                    <NavLink
                                        className="nav-link"
                                        to={`/admin/cms`}
                                    >
                                        CMS
                                    </NavLink>
                                </li>
                            </ul>{" "}
                        </div>
                        <div className="navbar-center">
                            <img src="/images/logo_dark.png" alt="Logo" width="30" height="46" />
                        </div>
                        <div className="navbar-right d-flex ml-auto">
                            <div className="header-icons align-middle">
                                <HeaderNotifications></HeaderNotifications>
                                <HeaderMessages></HeaderMessages>
                            </div>

                            <div className="navbar-user  ">
                                <div className="dropdown">
                                    <NavLink
                                        to={`/admin/dashboard`}
                                        id="sidebarIcon"
                                        className="dropdown-t nav-link dropdown-toggler-user"
                                        role="button"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    >
                                        <div className="avatar avatar-sm avatar-online">
                                            <img
                                                src={
                                                    this.context.state.user
                                                        .image
                                                }
                                                className="avatar-img user-avatar-img rounded-circle"
                                                alt=""
                                            />
                                        </div>
                                    </NavLink>

                                    <div
                                        className="dropdown-menu dropdown-menu-right hide"
                                        aria-labelledby="sidebarIcon"
                                    >
                                        <div className="username">
                                            Admin
                                        </div>
                                        <hr className="dropdown-divider" />
                                        <NavLink
                                            to={`/logout`}
                                            className="dropdown-item"
                                        >
                                            Logout
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        );
    }
}
Header.contextType = AppContext;
export default withRouter(({ location, ...props }) => {
    return <Header {...props}   />;
 });




// WEBPACK FOOTER //
// ./src/components/admin/Header.js